import script from "./login.vue?vue&type=script&setup=true&name=Login&lang=js"
export * from "./login.vue?vue&type=script&setup=true&name=Login&lang=js"

import "./login.vue?vue&type=style&index=0&id=1326405c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\php\\quick_wucode\\quick_wucode\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1326405c"]])

export default __exports__